var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy276(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M89.6,4c3.1,0,5.6,2.5,5.6,5.6v80c0,3.1-2.5,5.6-5.6,5.6h-80c-3.1,0-5.6-2.5-5.6-5.6v-80 C4,6.5,6.5,4,9.6,4H89.6 M89.6,0h-80C4.3,0,0,4.3,0,9.6v80c0,5.3,4.3,9.6,9.6,9.6h80c5.3,0,9.6-4.3,9.6-9.6v-80 C99.2,4.3,94.9,0,89.6,0L89.6,0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "lamps"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "rect6251_2_",
    style: {
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M24.6,17.1h50c4.6,0,8.2,3.7,8.2,8.3v48.5c0,4.6-3.7,8.3-8.2,8.3h-50c-4.6,0-8.2-3.7-8.2-8.3V25.3C16.4,20.8,20.1,17.1,24.6,17.1z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.4,
    y: 29.7,
    style: {
      fill: "#FFAF00",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 6.3,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3,
    y: 62.3,
    style: {
      fill: "#FFAF00",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 13.8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.1,
    y: 62.3,
    style: {
      fill: "#FFAF00",
      stroke: "#FFAF00",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 13.8,
    height: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy276);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-276.f45895aa11668e62f121a4d1beecc9c0.svg";
export { ForwardRef as ReactComponent };